import React, { useState } from 'react'
import { Formik, Form } from 'formik'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import * as AiIcons from 'react-icons/ai';
import { useQueryClient } from 'react-query'
import { useHistory } from "react-router-dom";
import FormikControl from '../../../hoc/formikComponents/FormikControl'
import swal from '@sweetalert/with-react';

function DeleteOrg() {
    const history = useHistory();
    const queryClient = useQueryClient();
    const [initialValues, setInitialValues] = useState({
        orgCode: 0,
        stage1: false,
        stage2: false,
        surveillance1: false,
        surveillance2: false
    })

    function onSelection(orgCode, formType) {
        //orgCode = 10009
        //formType = stage1
        setInitialValues({
            orgCode: orgCode,
            stage1: formType === "stage1" ? true : false,
            stage2: formType === "stage2" ? true : false,
            surveillance1: formType === "sur1" ? true : false,
            surveillance2: formType === "sur2" ? true : false
        })
    }
    const options = [
        { key: 'True', value: 'True' },
        { key: 'False', value: 'False' }
    ]
    const mutationDelete = useMutation((params) => Fetcher('patch', '/api/deleteorg/patch/deleteOrg', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                ToastInstance('Success',data.data.errorMsg)
                queryClient.invalidateQueries('listofrfq');
            } else {
                var msg = 'Organization - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Mandyas' + error)
        }
    })
    const { data: companyList, isLoading } = useQuery(
        'listofrfq',
        () => Fetcher('get', '/api/rfq/get/list/' + localStorage.getItem("userCode"), {}))

    function deleteData() {
        console.log("deleteData 38", initialValues)
        var titleMsg = "";
        if(initialValues.stage1){
            titleMsg = "Stage 1, Stage 2, Surv 1 & Surv 2";
        }else if(initialValues.stage2) {
            titleMsg = "Stage 2, Surv 1 & Surv 2";
        } else if(initialValues.surveillance1) {
            titleMsg = "Surv 1 & Surv 2";
        }else if(initialValues.surveillance2) {
            titleMsg = "Surv 2";
        }
        if(titleMsg !== ""){
            swal({
                title: "Are you sure to delete this record? This action will delete " + titleMsg + " data permanently...  ",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
                .then((willDelete) => {
                    if (willDelete) {
                        let item = {
                            orgInfo : initialValues
                        }
                        mutationDelete.mutate(item)
                    }
                    
                })
                .catch(err => {
                    ToastInstance('warning', 'Something Went Wrong..Please Try again')
                })
        }
        
        
    }

    //if (isLoading) return <div>Loading</div>
    return (
        <div>
            <div className="row">

                <div className="col-sm-12">
                    <div class="card-body table-responsive">
                        <table className="table table-bordered">
                            <thead className="table-primary">
                                <tr>
                                    <th scope="col" className="text-center" style={{ "width": "30px" }}>#</th>
                                    <th scope="col" className="text-center" style={{ "width": "80px" }}>Org Code </th>
                                    <th scope="col" className="text-center" style={{ "width": "120px" }}>Org Name</th>
                                    <th scope="col" className="text-center" style={{ "width": "120px" }}>Certification Type</th>
                                    <th scope="col" className="text-center" style={{ "width": "60px" }}>Stage 1</th>
                                    <th scope="col" className="text-center" style={{ "width": "60px" }}>Stage 2</th>
                                    <th scope="col" className="text-center" style={{ "width": "60px" }}>Sur 1</th>
                                    <th scope="col" className="text-center" style={{ "width": "60px" }}>Sur 2 </th>
                                    <th scope="col" className="text-center" style={{ "width": "60px" }}>Action</th>

                                </tr>
                            </thead>
                            <tbody>
                                {
                                    companyList && companyList.data.response && companyList.data.response.length > 0 && companyList.data.response.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td className="text-center">{index + 1}</td>
                                                <td className="text-center">{item.orgCode}</td>
                                                <td>{item.orgName}</td>
                                                <td>{item.typeOfCertification}</td>
                                                <td className="text-center">
                                                    <input type='radio' name="radio1" value="false" for="radionbutton1" onChange={() => onSelection(item.orgCode, "stage1")}/>&nbsp;
                                                </td>
                                                <td className="text-center">
                                                    <input type='radio' name="radio1" value="false" for="radionbutton1" onChange={() => onSelection(item.orgCode, "stage2")}/>&nbsp;
                                                </td>
                                                <td className="text-center">
                                                    <input type='radio' name="radio1" value="false" for="radionbutton1" onChange={() => onSelection(item.orgCode, "sur1")}/>&nbsp;
                                                </td>
                                                <td className="text-center">
                                                    <input type='radio' name="radio1" value="false" for="radionbutton1" onChange={() => onSelection(item.orgCode, "sur2")}/>&nbsp;
                                                </td>
                                                <td className="text-center">
                                                    <button className="btn btn-primary" type='button' disabled={initialValues.orgCode === item.orgCode ? false : true} onClick={() => deleteData()}>Delete</button>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default DeleteOrg                   